<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">HK1 - MAKLUMAT PENDAPATAN BERGAJI</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        width="20px"
        disabled
      ></v-text-field>


    <!-- DATATABLE  -->
    <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
          <v-card-title>
              Senarai
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <v-spacer></v-spacer>
              <v-btn
              color="error"
              small
              @click="dialogPengesahan=true;"
              >
                Padam
              </v-btn>

          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataHK1"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
            :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
          ><template v-slot:item.INCS11= "{ item }">
            {{ formatNumber(item.INCS11) }}
          </template>
          <template v-slot:item.INCS12= "{ item }">
            {{ formatNumber(item.INCS12) }}
          </template>
          <template v-slot:item.INCS13= "{ item }">
            {{ formatNumber(item.INCS13) }}
          </template>
          <template v-slot:item.INCS14= "{ item }">
            {{ formatNumber(item.INCS14) }}
          </template>
          <template v-slot:item.INCS15= "{ item }">
            {{ formatNumber(item.INCS15) }}
          </template>
          <template v-slot:item.INCS16= "{ item }">
            {{ formatNumber(item.INCS16) }}
          </template>
          <template v-slot:item.INCS17= "{ item }">
            {{ formatNumber(item.INCS17) }}
          </template>
          <template v-slot:item.INCS18= "{ item }">
            {{ formatNumber(item.INCS18) }}
          </template>
          <template v-slot:item.INCS19a= "{ item }">
            {{ formatNumber(item.INCS19a) }}
          </template>
          <template v-slot:item.INCS19b= "{ item }">
            {{ formatNumber(item.INCS19b) }}
          </template>
          <template v-slot:item.INCS19c= "{ item }">
            {{ formatNumber(item.INCS19c) }}
          </template>
          <template v-slot:item.INCS19 = "{ item }">
            {{ formatNumber(item.INCS19) }}
          </template>
          <template v-slot:item.INCS01= "{ item }">
            {{ formatNumber(item.INCS01) }}
          </template>
           
        
        
        
           </v-data-table>
        </v-card>
    </v-card>   


<v-card>
  <v-card-title>
    Pendapatan daripada pekerjaan bergaji
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <!-- s24 -->
      <v-row v-show="showS24">
        <v-col>
        S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
        <v-autocomplete
            :items="masco"
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="PK"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s25 -->
      <v-row v-show="showS25">
        <v-col>
        S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
        <v-autocomplete
            :items='msic'
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="PN"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s26 -->
      <v-row>
        <v-col>
        S26 : Nyatakan tempoh bagi soalan S24 <strong>[ dalam dua belas bulan (12) yang lalu ][M]</strong>
          <v-row>
            <!-- datepicker mula -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="dateMula"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateMula"
                    label="Mula"
                    readonly
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateMula"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(dateMula)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- datepicker tamat -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="dateTamat"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTamat"
                    label="Tamat"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTamat"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(dateTamat);"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- tempoh Sebenar -->
            <!-- <v-col cols="2">
              <v-autocomplete
                  min="0"
                  maxlength="2"
                  :items="tambahlookupbulan"
                  v-model="Msebenar"
                  label="Tempoh Sebenar(bulan)"
                  outlined
                  disabled
                  dense
                  :item-text="item => item.id"
                  item-value="id"
              ></v-autocomplete>
            </v-col> -->

            <!-- tempoh -->
            <v-col cols="4">
              <v-autocomplete
                  min="0"
                  maxlength="2"
                  :items="tambahlookupbulan"
                  v-model="M"
                  label="Tempoh Pengiraan(bulan)"
                  outlined
                  dense
                  :item-text="item => item.id"
                  item-value="id"
              ></v-autocomplete>
            </v-col> 
          
          </v-row>
        </v-col>
      </v-row>

  <v-form ref="form2" :disabled="disabledInput"> <!-- disable input kalau month NaN/empty -->
      <!-- s27 -->
      <v-row>
        <v-col>
          S27 : Upah dan gaji (sebelum potongan cukai pendapatan, caruman KWSP, dll)<strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS11]</strong>
          <v-row>
              <v-col cols="4" sm="6" md="4">                
                <v-text-field
                      v-model="INCS11"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits"
                     :rules="schemeRule.no7digit"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s28 -->
      <v-row>
        <v-col>
          S28 : Elaun (seperti elaun sara hidup, elaun pakar, elaun perumahan, elaun luar negeri, dll)<strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS12]</strong>
          <v-row>
            
            <v-col cols="4" sm="4" md="4">
               
              <v-text-field
                    v-model="INCS12"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s29 -->
      <v-row>
        <v-col>
          S29 : Bonus <strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS13]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
               
              <v-text-field
                    v-model="INCS13"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s30 -->
      <v-row>
        <v-col>
          S30 : Wang tunai lain (seperti komisen, tip, pendapatan daripada kerja lebih masa, dll)<strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS14]</strong>
          <v-row>          

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS14"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s31 -->
      <v-row>
        <v-col>
          S31 : Makanan percuma/konsesi <strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS15]</strong>
          <v-row>         

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS15"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s32 -->
      <v-row>
        <v-col>
          S32 : Tempat menginap percuma/konsesi <strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS16]</strong>
          <v-row>           

            <v-col cols="4" sm="4" md="4">
              
              <v-text-field
                    v-model="INCS16"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s33 -->
      <v-row>
        <v-col>
          S33 : Barang pengguna dan perkhidmatan percuma/konsesi <strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS17]</strong>
          <v-row>          

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS17"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s34-->
      <v-row>
        <v-col>
          S34 : Pembayaran lain yang diterima berupa mata benda (seperti padi, getah, kelapa, dll) <strong> [ mengikut tempoh yang dinyatakan di soalan S24 ]</strong> <strong>[INCS18]</strong>
          <v-row>            

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS18"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s35-->
      <v-row>
        <v-col>
          S35 : Caruman majikan kepada:
          <v-row class="mt-2">
            a) KWSP <strong>[INCS19a]</strong>        

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS19a"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            b) PERKESO <strong>[INCS19b]</strong>           

            <v-col cols="4" sm="4" md="4">              
              <v-text-field
                    v-model="INCS19b"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            a) Lain-lain <strong>[INCS19c]</strong>           

            <v-col cols="4" sm="4" md="4">
              
              <v-text-field
                    v-model="INCS19c"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            Jumlah Caruman <strong>[INCS19]</strong>
            <v-col cols="4" sm="4" md="4">
              
              <v-text-field
                    v-model="INCS19"
                    label="RM"
                    outlined
                    type="number"
                    dense                    
                    disabled
                    @change="kiraINCS01()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s36-->
      <v-row>
        <v-col>
          S36 : Jumlah Pendapatan Pekerjaan Bergaji <strong>[ mengikut tempoh yang dinyatakan di soalan S24 ] </strong><strong>[INCS01]</strong>
          <v-col>
            
              <v-text-field
                  v-model="INCS01"
                  label="RM"
                  outlined
                  disabled
                  dense                  
              ></v-text-field>
          </v-col>

        </v-col>
      </v-row>
    </v-form>
    </v-form>
    
      <!-- s37 -->
      <v-row>
        <v-col cols="6">
        S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="KL"
        ></v-select>
        </v-col>
      </v-row>

  </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK1()"
    >
      Kemaskini
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('2')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  
 
<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>



<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>


</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID


    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        disabledInput: true,
        butangSimpan: true,
        butangKemaskini: false,
        showS24: true,
        showS25: true,

        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        kemaskiniDialog: false,
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        dialogPengesahan:false,
        
        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        selectedData: [],
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        //R:1,

        PK:'',
        PN:'',
        menu1:'',
        dateMula:'',
        menu2:'',
        dateTamat:'',
        M:'',
        // Msebenar:0,
        INCS11:0,
        INCS11B:0,
        INCS12:0,
        INCS12B:0,
        INCS13:0,
        INCS13B:0,
        INCS14:0,
        INCS14B:0,
        INCS15:0,
        INCS15B:0,
        INCS16:0,
        INCS16B:0,
        INCS17:0,
        INCS17B:0,
        INCS18:0,
        INCS18B:0,
        INCS19a:0,
        INCS19aB:0,
        INCS19bB:0,
        INCS19b:0,
        INCS19cB:0,
        INCS19c:0,
        //INCS19:0,
        //INCS01:0,
        KL:{"id":0},

        NOAIR:'',
        Bil:'',
        IDBPK:'',
        HK1PK:'',
        HK1PN:'',
        HK1Tp:'',
        PENHK1:'',
        dataHK1: [],
        // rules: [
        // value => !!value || 'Required.',
        // ],
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          // { text: 'Bil. Pekerjaan', value: 'Bil' },
          //{ text: 'IDBPK', value: 'IDBPK' },
          { text: 'HK1-PK', value: 'HK1PK' },
          { text: 'HK1-PN', value: 'HK1PN' },
          { text: 'Tempoh', value: 'M' },
          { text: 'INCS11', value: 'INCS11' },
          { text: 'INCS12', value: 'INCS12' },
          { text: 'INCS13', value: 'INCS13' },
          { text: 'INCS14', value: 'INCS14' },
          { text: 'INCS15', value: 'INCS15' },
          { text: 'INCS16', value: 'INCS16' },
          { text: 'INCS17', value: 'INCS17' },
          { text: 'INCS18', value: 'INCS18' },
          { text: 'INCS19a', value: 'INCS19a' },
          { text: 'INCS19b', value: 'INCS19b' },
          { text: 'INCS19c', value: 'INCS19c' },
          { text: 'INCS19', value: 'INCS19' },
          { text: 'INCS01', value: 'INCS01' },
          { text: 'KL', value: 'HK1KL' },
          //{ text: 'HKI Pendapatan', value: 'PENHK1' },
        ],
       ///////////link untuk ke page/////////////////////
       breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'HK1',
          disabled: true,
          href: 'hk1',
        },
      ],
    
      valid: true,
      select: null,
      checkbox: false,
    }),
    methods: {
      formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
        return value.replace(/,/g, '');
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 7) {
            event.preventDefault();
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async simpan (){
        
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

                //const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/HK1`, {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK1`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                HK1PK: this.PK.kod,
                HK1PN:  this.PN.kod,
                Bulan: this.Bulan,
                Tahun: this.Tahun,
                P: this.Ps,//pusingan
                // dateMula: this.dateMula,
                // dateTamat: this.dateTamat,
                M: this.M,
                INCS11: this.INCS11,
                INCS11B: this.INCS11B,  
                INCS12: this.INCS12,
                INCS12B: this.INCS12B,
                INCS13: this.INCS13,
                INCS13B: this.INCS13B,
                INCS14: this.INCS14,
                INCS14B: this.INCS14B,
                INCS15: this.INCS15,
                INCS15B: this.INCS15B,
                INCS16: this.INCS16,
                INCS16B: this.INCS16B,
                INCS17: this.INCS17,
                INCS17B: this.INCS17B,
                INCS18: this.INCS18,
                INCS18B: this.INCS18B,
                INCS19: this.INCS19,
                INCS19a: this.INCS19a,
                INCS19aB: this.INCS19aB,
                INCS19b: this.INCS19b,
                INCS19bB: this.INCS19bB,
                INCS19c: this.INCS19c,
                INCS19cB: this.INCS19cB,
                INCS01: this.INCS01,
                HK1KL: this.KL.id,
                
                /////////calculate total untuk di update ke table JR5
                totalINCS11: this.totalINCS11, 
                totalINCS12: this.totalINCS12,
                totalINCS13: this.totalINCS13,
                totalINCS14: this.totalINCS14,
                totalINCS15: this.totalINCS15,
                totalINCS16: this.totalINCS16,
                totalINCS17: this.totalINCS17,
                totalINCS18: this.totalINCS18,
                totalINCS19: this.totalINCS19,
                totalINCS19a: this.totalINCS19a,
                totalINCS19b: this.totalINCS19b,
                totalINCS19c: this.totalINCS19c,
                totalINCS01: this.totalINCS01,
              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                //setTimeout(() => (this.successDialog = false), 2000);
                //this.reset();
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
      async updateHK1(){
        
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK1`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                HK1PK: this.PK,
                HK1PN:  this.PN,
                // dateMula: this.dateMula,
                // dateTamat: this.dateTamat,
                M: this.M,
                INCS11: this.INCS11,
                INCS11B: this.INCS11B,  
                INCS12: this.INCS12,
                INCS12B: this.INCS12B,
                INCS13: this.INCS13,
                INCS13B: this.INCS13B,
                INCS14: this.INCS14,
                INCS14B: this.INCS14B,
                INCS15: this.INCS15,
                INCS15B: this.INCS15B,
                INCS16: this.INCS16,
                INCS16B: this.INCS16B,
                INCS17: this.INCS17,
                INCS17B: this.INCS17B,
                INCS18: this.INCS18,
                INCS18B: this.INCS18B,
                INCS19: this.INCS19,
                INCS19a: this.INCS19a,
                INCS19aB: this.INCS19aB,
                INCS19b: this.INCS19b,
                INCS19bB: this.INCS19bB,
                INCS19c: this.INCS19c,
                INCS19cB: this.INCS19cB,
                INCS01: this.INCS01,
                HK1KL: this.KL.id,
                /////////calculate total untuk di update ke table JR5
                totalINCS11: this.totalINCS11, 
                totalINCS12: this.totalINCS12,
                totalINCS13: this.totalINCS13,
                totalINCS14: this.totalINCS14,
                totalINCS15: this.totalINCS15,
                totalINCS16: this.totalINCS16,
                totalINCS17: this.totalINCS17,
                totalINCS18: this.totalINCS18,
                totalINCS19: this.totalINCS19,
                totalINCS19a: this.totalINCS19a,
                totalINCS19b: this.totalINCS19b,
                totalINCS19c: this.totalINCS19c,
                totalINCS01: this.totalINCS01,
              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                //setTimeout(() => (this.successDialog = false), 2000);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }

        
      },
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK1"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK1 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK1?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
      
            })
            var dataz = res.data.data
            this.dataHK1 = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
          this.selectedData = [];
          this.selectedData = row;
          //console.log(this.selectedData.INCS01)
          // this.kemaskiniDialog = true;
          // setTimeout(() => (this.kemaskiniDialog = false), 1000);


          // Reset and set the dialog visibility in a reactive way
          this.kemaskiniDialog = true;

          

          this.showS24 = false;
          this.showS25 = false;
          this.butangSimpan = false;
          this.butangKemaskini = true;

          this.NOAIR = row.NOAIR;
          this.Bil = row.Bil;
          this.PK = row.HK1PK;
          this.PN = row.HK1PN;
          // this.dateMula = row.dateMula;
          // this.dateTamat = row.dateTamat;
          this.M = row.M;
          this.INCS11 = this.stripCommas(row.INCS11);
          // this.INCS11B =  row.INCS11B;
          this.INCS12 = this.stripCommas(row.INCS12);
          // this.INCS12B = row.INCS12B;
          this.INCS13 = this.stripCommas (row.INCS13);
          // this.INCS13B = row.INCS13B;
          this.INCS14 = this.stripCommas(row.INCS14);
          // this.INCS14B = row.INCS14B;
          this.INCS15 = this.stripCommas(row.INCS15);
          // this.INCS15B = row.INCS15B;
          this.INCS16 = this.stripCommas(row.INCS16);
          // this.INCS16B = row.INCS16B;
          this.INCS17 = this.stripCommas(row.INCS17);
          // this.INCS17B = row.INCS17B;
          this.INCS18 = this.stripCommas(row.INCS18);
          // this.INCS18B = row.INCS18B;
          this.INCS19 = this.stripCommas(row.INCS19);
          this.INCS19a = this.stripCommas(row.INCS19a);
          // this.INCS19aB = row.INCS19aB;
          this.INCS19b = this.stripCommas(row.INCS19b);
          // this.INCS19bB = row.INCS19bB;
          this.INCS19c = this.stripCommas(row.INCS19c);
          // this.INCS19cB = row.INCS19cB;
          this.INCS01 = this.stripCommas(row.INCS01);
          this.PENHK1 = row.PENHK1;

          if(row.HK1KL == 1){
            this.KL = this.yaTidak[0];
          }
          if(row.HK1KL == 2){
            this.KL = this.yaTidak[1];
          }


          // or just do something with your current clicked row item data
          //console.log(row)
      },
      // kiraTempoh(){
        
      //   var d1 = new Date(this.dateMula);
      //   var d2 = new Date(this.dateTamat);
        
      //   var months;
      //   months = (d2.getFullYear() - d1.getFullYear()) * 12;
      //   months -= d1.getMonth();
      //   months += d2.getMonth();
      //   this.M = months;

      //   // if(months <= 0){
      //   //   // To calculate the time difference of two dates
      //   //   var Difference_In_Time = d2.getTime() - d1.getTime();
            
      //   //   // To calculate the no. of days between two dates
      //   //   var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      //   //   months = '0.'+Difference_In_Days
      //   //   console.log(months)
      //   // }else{
      //   //   console.log(months)
      //   // }
        
      //   // return months <= 0 ? 0 : months;
      // },
      kiraINCS19(){
        var total = 0;
        total = Number(this.INCS19a) + Number(this.INCS19b) + Number(this.INCS19c)
        this.INCS19 = total;
      },
      kiraINCS01(){
        var total = 0;
        total = Number(this.INCS11) + Number(this.INCS12) + Number(this.INCS13) + Number(this.INCS14)
        + Number(this.INCS15) + Number(this.INCS16) + Number(this.INCS17) + Number(this.INCS18) + Number(this.INCS19)
        this.INCS01 = total;
      },
      goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
      
          if(this.KL.id == "1"){
            this.$router.push({name: "JRB"});
          }
          if(this.KL.id == "2"){
            if(this.NOAIR == "01"){
              this.$router.push({name: "hk7"});
            }else{
              this.$router.push({name: "ringkasanMaklumatIR"});
            }
            
          }
         
        }   
      }
    },
    watch:{
      INCS11B(){
        if(this.M == 0){
          this.INCS11 = Number(this.INCS11B)
        }
        else{
          this.INCS11 = Number(this.INCS11B)*Number(this.M);
        }
        this.kiraINCS01();
        
      },
      INCS12B(){
        if(this.M == 0){
          this.INCS12 = Number(this.INCS12B)
        }
        else{
          this.INCS12 = Number(this.INCS12B)*Number(this.M);
        }
        this.kiraINCS01();
        
      },
      INCS13(){
        this.kiraINCS01();
      },
      INCS14(){
        this.kiraINCS01();
      },
      INCS15B(){
        if(this.M == 0){
          this.INCS15 = Number(this.INCS15B)
        }
        else{
          this.INCS15 = Number(this.INCS15B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS16B(){
        if(this.M == 0){
          this.INCS16 = Number(this.INCS16B)
        }
        else{
          this.INCS16 = Number(this.INCS16B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS17B(){
        if(this.M == 0){
          this.INCS17 = Number(this.INCS17B)
        }
        else{
          this.INCS17 = Number(this.INCS17B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS18B(){
        if(this.M == 0){
          this.INCS18 = Number(this.INCS18B)
        }
        else{
          this.INCS18 = Number(this.INCS18B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS19aB(){
        if(this.M == 0){
          this.INCS19a = Number(this.INCS19aB)
        }
        else{
          this.INCS19a = Number(this.INCS19aB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19bB(){
        if(this.M == 0){
          this.INCS19b = Number(this.INCS19bB)
        }
        else{
          this.INCS19b = Number(this.INCS19bB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19cB(){
        if(this.M == 0){
          this.INCS19c = Number(this.INCS19cB)
        }
        else{
          this.INCS19c = Number(this.INCS19cB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19(){
        this.kiraINCS01();
      },
      M(val){
    
        if(isNaN(val)){
            this.disabledInput = true;
          }else{
            this.disabledInput = false;
        }
      },
      PK(val){
        let found = this.dataHK1.some(ele => ele.HK1PK === val.kod);
        if(found == true){
          this.PK = [];
          this.errorDialog = true;
          this.errMessage = 'Pekerjaan Sudah Wujud dan telah diisi! Sila Pilih Pekerjaan Lain';
          setTimeout(() => (this.errorDialog = false), 2000);
        }
      }
      
    },
    ////nama variable digunakan sebagai function name dan tidak perlu di dideclare
    computed:{
        tambahlookupbulan() {
        return lookup.getBulan();
        },
        INCS19(){

          var total = 0;
          total = Number(this.INCS19a) + Number(this.INCS19b) + Number(this.INCS19c)
          return total;

        },
        
        INCS01(){
          var total = 0;
          total = Number(this.INCS11) + Number(this.INCS12) + Number(this.INCS13) + Number(this.INCS14)
          + Number(this.INCS15) + Number(this.INCS16) + Number(this.INCS17) + Number(this.INCS18) + Number(this.INCS19)
          return total;
        },
        totalINCS11: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS11 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS11)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          if(this.selectedData.INCS11){
              total = total + Number(this.INCS11) - Number(this.selectedData.INCS11);
          }else{
              total = total + Number(this.INCS11) ;
          }
          
          return total;
        },
        totalINCS12: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS12 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS12)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          if(this.selectedData.INCS12){
            total = total + Number(this.INCS12) - Number(this.selectedData.INCS12);
          }else{
            total = total + Number(this.INCS12);
          }
            
          return total;
        },
        totalINCS13: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS13 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS13)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          if(this.selectedData.INCS13){
              total = total + Number(this.INCS13) - Number(this.selectedData.INCS13);
          }else{
              total = total + Number(this.INCS13) ;
          }
          //total = total + Number(this.INCS13) - Number(this.selectedData.INCS13);
          return total;
        },
        totalINCS14: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS14 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS14)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS14) - Number(this.selectedData.INCS14);
          if(this.selectedData.INCS14){
              total = total + Number(this.INCS14) - Number(this.selectedData.INCS14);
          }else{
              total = total + Number(this.INCS14) ;
          }
          return total;
        },
        totalINCS15: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS15 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS15)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS15) - Number(this.selectedData.INCS15);
          if(this.selectedData.INCS15){
              total = total + Number(this.INCS15) - Number(this.selectedData.INCS15);
          }else{
              total = total + Number(this.INCS15) ;
          }
          return total;
        },
        totalINCS16: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS16 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS16)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS16) - Number(this.selectedData.INCS16);
          if(this.selectedData.INCS16){
              total = total + Number(this.INCS16) - Number(this.selectedData.INCS16);
          }else{
              total = total + Number(this.INCS16) ;
          }
          return total;
        },
        totalINCS17: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS17 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS17)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS17) - Number(this.selectedData.INCS17);
          if(this.selectedData.INCS17){
              total = total + Number(this.INCS17) - Number(this.selectedData.INCS17);
          }else{
              total = total + Number(this.INCS17) ;
          }
          return total;
        },
        totalINCS18: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS18 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS18)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS18) - Number(this.selectedData.INCS18);
          if(this.selectedData.INCS18){
              total = total + Number(this.INCS18) - Number(this.selectedData.INCS18);
          }else{
              total = total + Number(this.INCS18) ;
          }
          return total;
        },
        totalINCS19a: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS19a yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS19a)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS19a) - Number(this.selectedData.INCS19a);
          if(this.selectedData.INCS19a){
              total = total + Number(this.INCS19a) - Number(this.selectedData.INCS19a);
          }else{
              total = total + Number(this.INCS19a) ;
          }
          return total;
        },
        totalINCS19b: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS19b yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS19b)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS19b) - Number(this.selectedData.INCS19b);
          if(this.selectedData.INCS19b){
              total = total + Number(this.INCS19b) - Number(this.selectedData.INCS19b);
          }else{
              total = total + Number(this.INCS19b) ;
          }
          return total;
        },
        totalINCS19c: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS19c yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS19c)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS19c) - Number(this.selectedData.INCS19c);
          if(this.selectedData.INCS19c){
              total = total + Number(this.INCS19c) - Number(this.selectedData.INCS19c);
          }else{
              total = total + Number(this.INCS19c) ;
          }
          return total;
        },
        totalINCS19: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS19 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS19)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS19) - Number(this.selectedData.INCS19);
          if(this.selectedData.INCS19){
              total = total + Number(this.INCS19) - Number(this.selectedData.INCS19);
          }else{
              total = total + Number(this.INCS19) ;
          }
          return total;
        },
        totalINCS01: function(){
          var total = 0;
          if(this.dataHK1.length >= 1){
            ///calculate semua value INCS01 yang telah di insert
            for(var i = 0; i < this.dataHK1.length ; i++){
              total = total + Number(this.dataHK1[i].INCS01)
            }
          }

          ///tambahkan total yang telah diinsert dengan current INCS11 yang bakal diinsert
          //total = total + Number(this.INCS01) - Number(this.selectedData.INCS01);
          if(this.selectedData.INCS01){
              total = total + Number(this.INCS01) - Number(this.selectedData.INCS01);
          }else{
              total = total + Number(this.INCS01) ;
          }
          return total;
        },
        schemeRule() {
          return schemeRule;
        },
        
    }
}
</script>

